export enum SaveTypeForProductionSchedule {
  SAVE = 'SAVE',
  SAVE_AND_QUIT = 'SAVE_AND_QUIT',
  SAVE_AND_CREATE_NEW = 'SAVE_AND_CREATE_NEW',
  SAVE_AND_GO_TO_PRESELECTION = 'SAVE_AND_GO_TO_PRESELECTION'
}
